<template>
    <div>

        <b-alert show variant="warning">
            <div class="flex flex-col items-center">
                <div>
                    <p>This platform this service operates on has been deprecated and is no longer receiving support. Certain operations, such as virtual consoles and remote power management, may cease to function.</p>
                    <p>We recommend upgrading to a modern Cloud Server to receive the benefits of dual zone (HA), improved performance, and ongoing platform support. Contact Sales for more information.</p>
                </div>
                <div>
                    <b-button variant="warning" href="mailto:sales@serversaustralia.com.au">Contact Sales</b-button>
                </div>
            </div>
        </b-alert>
        <!-- Status -->
        <sau-service-status :service="service"></sau-service-status>

        <!-- VPS Power Status -->
        <!-- <sau-vps-power-check></sau-vps-power-check> -->

        <!-- Pending Cancellation - now checked in sau-service-status -->
        <!-- <sau-cancellation-check class="pt-12"></sau-cancellation-check> -->

    </div>
</template>

<script>
import PowerCheck from './_PowerCheck'
export default {
    props:['service'],
    components: {
        'sau-vps-power-check': PowerCheck
    },
    created() {
    }
}
</script>

<style>
</style>
